import { WM_CONSUMER_ID } from 'services/utils/constants/config-values'

export default {
  login: {
    url: '/api/v1/login',
    method: 'POST',
    cache: 'no-cache',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
  resetPassword: {
    url: '/api/v1/forgotpassword',
    method: 'POST',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
  resetPasswordV3: {
    url: '/api/v3/forgotpassword',
    method: 'POST',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
  register: {
    url: '/api/v1/profile',
    method: 'POST',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
  registerV3: {
    url: '/api/v3/profile',
    method: 'POST',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
  registerBTC: {
    url: '/api/v2/profile',
    method: 'PUT',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  kickbox: {
    url: '/api/v1/validateEmail',
    method: 'POST',
    dataType: 'json',
    ignoreError: true,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  loginInfo: {
    url: '/api/v1/logininfo',
    method: 'GET',
    dataType: 'json',
    ignoreError: true,
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  token: {
    url: '/api/v1/token',
    method: 'GET',
    dataType: 'json',
    ignoreError: true,
    headers: {
      Accept: 'application/json',
    },
  },
  logout: {
    url: '/api/v1/logout?requestorigin=asda',
    method: 'GET',
    dataType: 'json',
    ignoreError: true,
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  authorize: {
    url: '/api/v1/authorize',
    method: 'GET',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  addAddress: {
    url: '/api/v1/address',
    method: 'POST',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  addMembership: {
    url: '/api/v1/membership',
    method: 'POST',
    cache: 'no-cache',
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  profile: {
    url: '/api/v1/profile',
    method: 'GET',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  registerColleague: {
    url: '/api/v1/profile',
    method: 'PUT',
    cache: 'no-cache',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  sngLogin: {
    url: '/api/v1/sng/login',
    method: 'POST',
    cache: 'no-cache',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
  lookupEmail: {
    url: '/api/v1/sng/lookupemail',
    method: 'POST',
    cache: 'no-cache',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
  sngRegister: {
    url: '/api/v1/sng/profile',
    method: 'POST',
    cache: 'no-cache',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
  updateSngAccount: {
    url: '/api/v1/sng/profile',
    method: 'PUT',
    cache: 'no-cache',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
  decryptEmail: {
    url: '/api/v1/decrypt',
    method: 'POST',
    cache: 'no-cache',
    contentType: 'application/json',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  updateProfile: {
    url: '/api/v1/profile',
    method: 'PUT',
    cache: 'no-cache',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  updateProfileV3: {
    url: '/api/v3/profile',
    method: 'PUT',
    cache: 'no-cache',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  updateExtProfile: {
    url: '/api/v1/ext-profile',
    method: 'PUT',
    cache: 'no-cache',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  addPreference: {
    url: '/api/v1/preference',
    method: 'POST',
    cache: 'no-cache',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  updatePreference: {
    url: '/api/v2/profile',
    method: 'PUT',
    cache: 'no-cache',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  getAddress: {
    url: '/api/v1/address',
    method: 'GET',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  addressSuggest: {
    url: '/api/v1/address/suggest',
    method: 'GET',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  editAddress: {
    url: '/api/v1/address',
    method: 'PUT',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  deleteAddress: {
    url: '/api/v1/address',
    method: 'DELETE',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  getContact: {
    url: '/api/v1/contact',
    method: 'GET',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  addContact: {
    url: '/api/v1/contact',
    method: 'POST',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
      'WM_CONSUMER.USER_ID': WM_CONSUMER_ID,
    },
  },
  editContact: {
    url: '/api/v1/contact',
    method: 'PUT',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  deleteContact: {
    url: '/api/v1/contact',
    method: 'DELETE',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  getCard: {
    url: '/api/v1/card',
    method: 'GET',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  addCard: {
    url: '/api/v1/card',
    method: 'POST',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
      'WM_CONSUMER.USER_ID': WM_CONSUMER_ID,
    },
  },
  editCard: {
    url: '/api/v1/card',
    method: 'PUT',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  deleteCard: {
    url: '/api/v1/card',
    method: 'DELETE',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  leaveBabyClub: {
    url: '/api/v1/ext-profile',
    method: 'DELETE',
    cache: 'no-cache',
    dataType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
  deleteAccount: {
    url: '/api/v2/account-delete',
    method: 'POST',
    cache: 'no-cache',
    dataType: 'json',
    ignoreError: true,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  },
}
